import React, { useState, useEffect } from 'react';
import userService from '../services/userService';
import UsersList from '../components/UsersList';
import UserFormModal from '../components/UserFormModal';
import './UsersPage.css';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await userService.getUsers();
      setUsers(data);
    } catch (err) {
      console.error('Error loading users:', err);
      setError('Fehler beim Laden der Benutzer');
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = () => {
    setEditingUser(null);
    setShowModal(true);
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setShowModal(true);
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm('Möchten Sie diesen Benutzer wirklich löschen?')) {
      try {
        await userService.deleteUser(userId);
        loadUsers();
      } catch (err) {
        console.error('Error deleting user:', err);
        setError('Fehler beim Löschen des Benutzers');
      }
    }
  };

  const handleToggleStatus = async (userId, isActive) => {
    // Optimistically update the UI
    setUsers(prevUsers => 
      prevUsers.map(user => 
        user.id === userId ? { ...user, active: isActive } : user
      )
    );

    try {
      await userService.toggleUserStatus(userId, isActive);
    } catch (err) {
      console.error('Error toggling user status:', err);
      setError('Fehler beim Ändern des Benutzerstatus');
      // Revert the change on error
      setUsers(prevUsers => 
        prevUsers.map(user => 
          user.id === userId ? { ...user, active: !isActive } : user
        )
      );
    }
  };

  const handleSaveUser = async (userData) => {
    try {
      if (editingUser) {
        await userService.updateUser(editingUser.id, userData);
      } else {
        await userService.createUser(userData);
      }
      setShowModal(false);
      loadUsers();
    } catch (err) {
      console.error('Error saving user:', err);
      throw err;
    }
  };

  return (
    <div className="users-page">
      <div className="page-header">
        <h1>Benutzerverwaltung</h1>
        <button className="add-button" onClick={handleAddUser}>
          Neuer Benutzer
        </button>
      </div>

      {error && (
        <div className="error-message">{error}</div>
      )}

      {loading ? (
        <div className="loading">Benutzer werden geladen...</div>
      ) : (
        <UsersList
          users={users}
          onEdit={handleEditUser}
          onDelete={handleDeleteUser}
          onToggleStatus={handleToggleStatus}
        />
      )}

      {showModal && (
        <UserFormModal
          user={editingUser}
          onSave={handleSaveUser}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default UsersPage;